// extracted by mini-css-extract-plugin
export default {"forgot-password":"reset-password_forgot-password__p7JMw","col":"reset-password_col__f9Wav","container-form":"reset-password_container-form__wsFfU"};